"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  return {
    Page: {
      margin: '0',
      display: 'flex',
      'flex-direction': 'column',
      flex: '1',
      '-ms-flex-preferred-size': 'auto',
      '& .page-title-bar': {
        display: 'flex',
        'flex-direction': 'row',
        '& .page-title': {
          'padding-bottom': '20px',
          margin: 0
        }
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map